import { ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ApiService } from '../../services/api.service';
import { SimpleTableComponent } from '../../generals/Components';
import { CartstatisticsdetailComponent } from '../cartstatisticsdetail/cartstatisticsdetail.component';

@Component({
  selector: 'app-cartstatistics',
  templateUrl: './cartstatistics.component.html',
  styleUrls: ['./cartstatistics.component.scss']
})
export class CartstatisticsComponent extends SimpleTableComponent<any> {

  constructor(
    private apiServiceRef: ApiService,
    private changeDetectionRef: ChangeDetectorRef,
    private dialogService: DialogService
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'statistics/cart';
  }

  showCartStatisticsDetailsModal(data: any): void {
    this.dialogService.open(CartstatisticsdetailComponent, {
      header: 'Kosár statisztika - ' + data.name,
      data: {
        id: data.id
      }
    });
  }
}
